import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
export function registerWorker(_x) {
  return _registerWorker.apply(this, arguments);
}

function _registerWorker() {
  _registerWorker = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(workerSrc) {
    var serviceWorkerRegistration;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            serviceWorkerRegistration = null;

            if (!('serviceWorker' in navigator)) {
              _context.next = 5;
              break;
            }

            _context.next = 4;
            return navigator.serviceWorker.register(workerSrc);

          case 4:
            serviceWorkerRegistration = _context.sent;

          case 5:
            return _context.abrupt("return", serviceWorkerRegistration);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _registerWorker.apply(this, arguments);
}